import React, { Component } from 'react';
import cx from 'classnames';

import Lottie from 'react-lottie';

import dataSpinner from './data/data.json';
import dataSpinnerInk from './data/data-ink.json';

export default class LoaderSpinnerPage extends Component {

  render() {
    const options = {
      loop: true,
      autoplay: true,
      animationData: true ? dataSpinnerInk : dataSpinner,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return (
      <div style={{ width: '300px', height: '300px' }} className={cx('spinnerPageWrapper')}>
        <Lottie width={300} height={300} options={options} />
      </div>
    );
  }

}
